import { authFetch, getStoredAuthToken } from './authFetch';
import { resolveAssetUrl } from './resolveAssetUrl';

const cache = new Map();
const inflight = new Map();

function toResolvedUrl(src) {
  if (!src) return '';
  if (typeof src === 'string') return resolveAssetUrl(src);
  return resolveAssetUrl(
    src?.thumbnail ||
      src?.thumb_url ||
      src?.medium ||
      src?.medium_url ||
      src?.large ||
      src?.large_url ||
      src?.url ||
      src
  );
}

export function peekAuthorizedImage(src) {
  const resolved = toResolvedUrl(src);
  if (!resolved) return undefined;
  return cache.get(resolved);
}

export function preloadAuthorizedImage(src) {
  const resolved = toResolvedUrl(src);
  if (!resolved) return Promise.resolve('');

  const cached = cache.get(resolved);
  if (cached) return Promise.resolve(cached);

  const pending = inflight.get(resolved);
  if (pending) return pending;

  const task = (async () => {
    const token = getStoredAuthToken();
    if (!token) {
      cache.set(resolved, resolved);
      return resolved;
    }

    try {
      const res = await authFetch(resolved);
      if (!res.ok) throw new Error(String(res.status));
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      cache.set(resolved, blobUrl);
      return blobUrl;
    } catch {
      cache.set(resolved, resolved);
      return resolved;
    } finally {
      inflight.delete(resolved);
    }
  })();

  inflight.set(resolved, task);
  return task;
}

export function preloadAuthorizedImages(sources) {
  return Promise.all(sources.map((src) => preloadAuthorizedImage(src)));
}
